export default "__VITE_ASSET__lt0Cz_K4__"